// @ts-nocheck
import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { fetch } from "@insite/client-framework/ServerSideRendering";
import { getCurrentUserIsGuest, getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { doValidatePassword } from "@store/Framework/Services/SessionService";

type HandlerType = ApiHandler<
    ValidatePasswordParameter,
    ValidatePasswordResult,
    {
        tokenSuccessfullyRequested?: boolean;
    }
>;

export interface ValidatePasswordParameter {
    userName: string;
    password: string;
    onError?: (error: string, statusCode?: number) => void;
    onSuccess?: () => void;
}

export interface ValidatePasswordResult {
    readonly access_token: string;
    readonly refresh_token: string;
    readonly expires_in: number;
    readonly error_description: string;
}

export const RequestAccessToken: HandlerType = async props => {
    const { enableTokenAuthentication } = getSettingsCollection(props.getState()).websiteSettings;
    const currentUserIsGuest = getCurrentUserIsGuest(props.getState());
    if (!enableTokenAuthentication && !currentUserIsGuest) {
        props.tokenSuccessfullyRequested = true;
        return;
    }

    const data = new URLSearchParams();
    data.append("grant_type", "password");
    data.append("username", props.parameter.userName);
    data.append("password", props.parameter.password);
    data.append("scope", "iscapi offline_access");

    const response = await fetch("/identity/connect/token", {
        method: "POST",
        body: data.toString(),
        headers: new Headers({
            "content-type": "application/x-www-form-urlencoded",
            Authorization: `Basic ${btoa("isc:009AC476-B28E-4E33-8BAE-B5F103A142BC")}`,
        }),
    });

    props.apiResult = await (response.json() as Promise<{
        readonly access_token: string;
        readonly refresh_token: string;
        readonly expires_in: number;
        readonly error_description: string;
    }>);

    props.tokenSuccessfullyRequested = response.ok;

    if (!response.ok) {
        props.parameter.onError?.(props.apiResult.error_description);
    }
};

export const RequestSession: HandlerType = async props => {
    if (!props.tokenSuccessfullyRequested) {
        return;
    }

    const { password, userName } = props.parameter;

    const session = await doValidatePassword({
        password,
        userName,
        accessToken: props.apiResult?.access_token,
    });

    if (session.successful) {
        props.parameter.onSuccess?.();
    } else {
        props.parameter.onError?.(session.errorMessage, session.statusCode);
    }
};

export const chain = [RequestAccessToken, RequestSession];

const validatePassword = createHandlerChainRunner(chain, "ValidatePassword");
export default validatePassword;
